<template lang="pug">
v-container
  h1 Создание модуля
  api-form(
    v-model="value"
    :fields="fields"
    :method="save"
    :successCallback="successCallback"
    :autosave="false"
    v-bind="$attrs"
  )
</template>
<script>
export default {
  data() {
    return {
      value: {
        is_escorted: false,
        is_pricing: false,
      },
    };
  },
  computed: {
    fields() {
      return [
        {
          text: 'Название',
          rules: 'required',
          value: 'name',
          component: 'v-text-field',
          component_attrs: {
            rounded: true,
            outlined: true,
            filled: true,
          },
        },
        {
          text: 'Описание',
          rules: 'required',
          value: 'description',
          component: 'v-text-field',
          component_attrs: {
            rounded: true,
            outlined: true,
            filled: true,
          },
        },
        // {
        //   text: 'Сопровождение модуля',
        //   value: 'is_escorted',
        //   component: 'v-checkbox',
        //   component_attrs: {
        //     rounded: true,
        //     outlined: true,
        //     trueValue: true,
        //     falseValue: false,
        //     filled: true,
        //   },
        // },
        // ...this.value.is_escorted ? [{
        //   text: 'Цена за пользователя (сопровождение)',
        //   rules: 'required',
        //   value: 'price_escort_per_user',
        //   component: 'v-text-field',
        //   component_attrs: {
        //     rounded: true,
        //     outlined: true,
        //     filled: true,
        //     type: 'number',
        //   },
        // }] : [],
        // {
        //   text: 'Платный',
        //   value: 'is_pricing',
        //   component: 'v-checkbox',
        //   component_attrs: {
        //     rounded: true,
        //     trueValue: true,
        //     falseValue: false,
        //     outlined: true,
        //     filled: true,
        //   },
        // },
        // ...this.value.is_pricing ? [{
        //   rules: 'required',
        //   text: 'Цена за пользователя',
        //   value: 'price_per_user',
        //   component: 'v-text-field',
        //   component_attrs: {
        //     rounded: true,
        //     outlined: true,
        //     filled: true,
        //     type: 'number',
        //   },
        // }] : [],

      ];
    },
  },
  methods: {
    successCallback({ data }) {
      this.$router.push({ name: 'ModuleViewUnits', params: { id: data.data.id }, query: { refresh: true } });
    },

    save({ data, obs }) {
      const payloads = {
        status: 2,
        is_escorted: false,
        is_pricing: false,
        ...data,
      };
      // if (this.course) {
      //   return this.course.update({ data: payloads, obs });
      // }

      return this.$api.modules.create(payloads, obs);
    },
  },
};
</script>
